import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Limpiar datos antiguos de localStorage si existen (migración de localStorage a sessionStorage)
    // Esto asegura que no haya datos residuales que puedan causar problemas
    if (localStorage.getItem('token') || localStorage.getItem('user')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
    
    // Check if user is already logged in (ahora desde sessionStorage)
    const currentUser = authService.getCurrentUser();
    if (currentUser && authService.isAuthenticated()) {
      setUser(currentUser);
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await authService.login(email, password);
      
      if (response.success && response.data) {
        // Los datos del usuario ya están guardados en sessionStorage por authService
        // Obtener y establecer el usuario inmediatamente
        const userData = authService.getCurrentUser();
        
        if (userData) {
          setUser(userData);
          return { success: true };
        } else {
          // Si no se puede obtener del localStorage, usar los datos de la respuesta
          setUser(response.data);
          return { success: true };
        }
      }
      return { 
        success: false, 
        message: response.Message || response.message || 'Error al iniciar sesión' 
      };
    } catch (error) {
      return {
        success: false,
        message: error.message || error.Message || 'Error al conectar con el servidor',
      };
    }
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    isAuthenticated: !!user,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

